import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './thumbnail.module.scss'

const Thumbnail = (props) => {
  const { imageSrc, altText, type, size, width, height, className, children } =
    props

  const selectVariation = (categoryId) => {
    switch (categoryId) {
      case 2:
      case 5:
        return 'secondary'
      case 3:
      case 7:
        return 'quaternary'
      case 4:
      case 6:
        return 'primaryLight'
      case 99:
        return 'gradient'
      default:
        return 'tertiary'
    }
  }

  const containerClasses = classNames(styles.container, className, {
    [styles[selectVariation(type)]]: selectVariation(type),
    [styles[size]]: size
  })

  const stylesContainer = {}
  if (width) stylesContainer.width = width
  if (height) stylesContainer.height = height

  return (
    <div className={containerClasses}>
      {imageSrc && <img src={imageSrc} alt={altText} />}
      {children}
    </div>
  )
}

Thumbnail.defaultProps = {
  imageSrc: null,
  altText: null,
  type: null,
  size: null,
  width: null,
  height: null,
  className: null,
  children: null
}

Thumbnail.propTypes = {
  imageSrc: PropTypes.string,
  altText: PropTypes.string,
  type: PropTypes.number,
  size: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ])
}

export default Thumbnail
